import { render } from "./RecycleHistory.vue?vue&type=template&id=307d57e8&scoped=true"
import script from "./RecycleHistory.vue?vue&type=script&lang=ts"
export * from "./RecycleHistory.vue?vue&type=script&lang=ts"

import "./RecycleHistory.vue?vue&type=style&index=0&id=307d57e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-307d57e8"

export default script